export const PRIVILEGE_TYPE = {
  HasClientAppPrivilege: 10,
  HasAdminAppPrivilege: 11,
  HasDataSyncPrivilege: 12,
  HasGridUnlockPrivilege: 13,
  SuperAdminPrivilege: 14,
  BenefitAdminPrivilege: 15,
  SalesUserPrivilege: 16,
  BrokerUserPrivilege: 17,
  ContactUserPrivilege: 18,
  SubmitContributionModalPrivilege: 19,
  BAMUserPrivilege: 20,
  GlobalSalesUserPrivilege: 21,
  // Granted at login when the user appears in the SalesAdminMapping table.
  // Read-only: the three menu reports plus a view-only Dashboard.
  SalesAdminPrivilege: 22,
};

// Mirror of Prestige.BenefitsOE.Shared/Consts/FeatureKeys.cs. The server is
// authoritative - the admin dropdown is populated from the /featurekeys
// endpoint - but consuming code needs a literal at author time, so the strings
// are duplicated here on purpose. A test in
// src/data/services/__tests__/featureAccessService.test.js fails if the two
// drift apart.
// Values are lowercase: feature keys are stored and compared lowercase (see
// FeatureKeys.Normalize on the server). useFeatureAccess lowercases whatever it
// is given, so a call site passing mixed case still resolves.
export const FEATURE_KEYS = {
  NewRenewalDashboard: "newrenewaldashboard",
  // Clients in the Aetna program may only submit a contribution model with a
  // single medical carrier.
  Aetna: "aetna",
  // Paired-carrier variants: one medical carrier, or two where one of them is
  // the paired carrier. Both take precedence over Aetna above. The rule itself
  // is evaluated server side - see useQueryGetClientRateModelSubmitCarrierRule -
  // so the paired carrier ids never reach this bundle.
  AetnaUhc: "aetna-uhc",
  AetnaOxford: "aetna-oxford",
  // Blocks a client from the portal entirely for the OE period the admin row
  // is scoped to - see ClientLayout.jsx, which renders a "no active Open
  // Enrollment" message instead of the normal drawer/content when this key
  // is enabled for the client. Server-enforced too, see BaseController.
  Blocked: "blocked",
};
